// extracted by mini-css-extract-plugin
export default {"btop":"_56f863def6 _954a2dd9c4 _32c0cdce1e","icon":"_88af88cbb1 _4753903254","btoppink":"_4141bc8508 f093703617"};